// /src/pages/private/admin/academyTabs/courseExam/CourseExamDocumentPanel.jsx

import React from "react";
import PrivateLexicalPage from "../../../../../components/PrivateLexicalPage";

export default function CourseExamDocumentPanel({ document }) {
  if (!document?.documentName) return null;

  return (
    <div className="course-exam-document-panel">
      <div className="course-exam-document-panel__head">
        <h4 className="course-exam-document-panel__title">{document.label}</h4>
        {document.version && (
          <span className="course-exam-document-panel__version">v{document.version}</span>
        )}
      </div>

      <PrivateLexicalPage
        documentName={document.documentName}
        wrapperClass="course-exam-document-panel__viewer"
        containerClass="course-exam-document-viewer private-container"
        hidePublicToc
        hideReadProgressMeta
      />
    </div>
  );
}
